import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventsService {

    constructor() { }

    private eventsSubject = new Subject<any>();

    publishEvent(data: any) {
        this.eventsSubject.next(data);
    }

    listenOnEvents(): Subject<any> {
        return this.eventsSubject;
    }
}

export enum ApplicationEvents {
    MANAGE_LEFT_SIDEBAR_CONTACTS = 'MANAGE_LEFT_SIDEBAR_CONTACTS',
    IN_CHAT = 'IN_CHAT',
    IN_CALL = 'IN_CALL',
    ON_USER_NOT_AVAILABLE_ACTION = 'ON_USER_NOT_AVAILABLE_ACTION',
    VIDEO_CALL_CONTACT_ID = 'VIDEO_CALL_CONTACT_ID',
    NEW_CHAT_TEXT_INCOMING_MESSAGE = 'NEW_CHAT_TEXT_INCOMING_MESSAGE',
    TOOLBAR_VIDEO_CALL_START = 'TOOLBAR_VIDEO_CALL_START',
    TOOLBAR_VIDEO_CALL_STOP = 'TOOLBAR_VIDEO_CALL_STOP',
    TOOLBAR_VIDEO_CALL_TIMEOUT = 'TOOLBAR_VIDEO_CALL_TIMEOUT'
}
